export const colors = {
  pink: '#ff576a',
};
